import { SignInForm } from '@/components'
import { Footer } from '@/components/nav/Footer'

export function SignInPage() {
    return (
        <>
            <section className="bg-gray-50 dark:bg-gray-900">
                <SignInForm />
            </section>
            <Footer />
        </>
    )
}
